<template>
  <!-- categoria -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Categoria
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.category"
          :initialValue="store.itensForm.values.category"
          @selected-data="(val) => (store.itensForm.values.category = val)"
        />
      </div>
    </div>
  </div>

  <!-- tipo -->
  <div class="md:col-span-1">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Tipo
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.type"
          :initialValue="store.itensForm.values.type"
          @selected-data="(val) => (store.itensForm.values.type = val)"
        />
      </div>
    </div>
  </div>

  <!-- peso -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.peso"
      v-model="store.itensForm.values.peso"
      :info="'Peso'"
      label="Peso"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton @click="store.itensForm.values.peso = undefined" />
      </template>
    </BaseInput>
  </div>

  <!-- numeração -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.numeracao"
      v-model="store.itensForm.values.numeracao"
      :info="'TAG'"
      label="TAG"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.values.numeracao = undefined"
        />
      </template>
    </BaseInput>
  </div>

  <!-- cod. do cilindro -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.cod"
      v-model="store.itensForm.values.cod"
      :info="'Cod. do cilindro'"
      label="Cod. cilindro"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.values.cod = undefined"
        />
      </template>
    </BaseInput>
  </div>

  <!-- estado fisico -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado físico
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.condicao"
          :initialValue="store.itensForm.values.condicao"
          @selected-data="(val) => (store.itensForm.values.condicao = val)"
        />
      </div>
    </div>
  </div>

  <!-- estado fisico obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.condicao?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.condicao_descript"
        :info="'Inadequação física'"
        label="Danos, lacres, pintura..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.condicao_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- etiqueta -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Estado da etiqueta
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.condicao"
          :initialValue="store.itensForm.values.etiqueta"
          @selected-data="(val) => (store.itensForm.values.etiqueta = val)"
        />
      </div>
    </div>
  </div>

  <!-- etiqueta obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values?.etiqueta?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.etiqueta_descript"
        :info="'Inadequação da etiqueta'"
        label="Sem etiqueta, danificada..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.etiqueta_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- inmetro -->
  <div class="md:col-span-1">
    <BaseInput
      type="text"
      name="itensForm.values.codInmetro"
      v-model="store.itensForm.values.codInmetro"
      :info="'Cod. inmetro'"
      label="Cod. inmetro"
      :required-field="false"
      :activeDefault="false"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.values.codInmetro = undefined"
        />
      </template>
    </BaseInput>
  </div>

  <!-- manometros -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Manometros
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.manometros"
          :initialValue="store.itensForm.values.manometros"
          @selected-data="(val) => (store.itensForm.values.manometros = val)"
        />
      </div>
    </div>
  </div>

  <!-- manometro obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.manometros?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.manometros_descript"
        :info="'Inadequação do manometro'"
        label="Despressurizado, danificado..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.manometros_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- sinalização -->
  <div class="md:col-span-2">
    <div class="md:col-span-2 mt-1.5">
      <label class="text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Sinalização
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.sinalizacao"
          :initialValue="store.itensForm.values.sinalizacao"
          @selected-data="(val) => (store.itensForm.values.sinalizacao = val)"
        />
      </div>
    </div>
  </div>

  <!-- sinalização obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.sinalizacao?.value == 'inadequado'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.sinalizacao_descript"
        :info="'Inadequação da sinalização'"
        label="Apagada, sem sinalização..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.sinalizacao_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- obstrução -->
  <div class="md:col-span-1">
    <div class="md:col-span-2 mt-1.5">
      <label class="-mt-1 text-left flex pl-1 text-xs text-[#2b3038]" for="form.type">
        Livre de obstrução
      </label>
      <div class="h-10 flex rounded items-center">
        <SimpleSelect
          class="mt-1 px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent"
          :data="extinguisher.obstru"
          :initialValue="store.itensForm.values.obstru"
          @selected-data="(val) => (store.itensForm.values.obstru = val)"
        />
      </div>
    </div>
  </div>

  <!-- obstrução obs -->
  <Transition mode="out-in">
    <div class="md:col-span-2" v-if="store.itensForm.values.obstru?.value == 'nao'">
      <BaseInput
        type="text"
        name="itensForm.values.peso"
        v-model="store.itensForm.values.obstru_descript"
        :info="'Detalhes da obstrução'"
        label="Fora de vista, atrás de..."
        :required-field="true"
        :activeDefault="true"
      >
        <template #append>
          <CleanInputButton @click="store.itensForm.values.obstru_descript = undefined" />
        </template>
      </BaseInput>
    </div>
  </Transition>

  <!-- TH realizado em -->
  <div class="md:col-span-2">
    <BaseInput
      type="date"
      name="itensForm.next_check"
      v-model="store.itensForm.values.th"
      :info="'TH. realizado em'"
      label="Teste hidrostático"
      :required-field="false"
      :activeDefault="true"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.values.th = null"
        />
      </template>
    </BaseInput>
  </div>

  <!-- vencimento do TH -->
  <div class="md:col-span-2">
    <BaseInput
      type="date"
      name="itensForm.next_check"
      v-model="store.itensForm.th_expiration"
      :info="'Vencimento do TH.'"
      label="Vencimento do teste hidrostático"
      :required-field="false"
      :activeDefault="true"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.th_expiration = null"
        />
      </template>
    </BaseInput>
  </div>

  <!-- vencimento do extintor -->
  <div class="md:col-span-2">
    <BaseInput
      type="date"
      name="itensForm.validity_expiration"
      v-model="store.itensForm.validity_expiration"
      :info="'Validade do extintor'"
      label="Validade do extintor"
      :required-field="false"
      :activeDefault="true"
    >
      <template #append>
        <CleanInputButton
          @click="store.itensForm.validity_expiration = null"
        />
      </template>
    </BaseInput>
  </div>

</template>

<script setup>
import CleanInputButton from '../../utils/CleanInputButton.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import { dataExtinguisher } from '../../store'
import { extinguisher } from '../../lookups/form'

const store = dataExtinguisher.state
</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
